import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-stone-950 text-stone-50 py-24 px-4 relative overflow-hidden" data-id="element-90">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(217,119,6,0.15)_0,rgba(28,25,23,1)_100%)] pointer-events-none" data-id="element-91" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-92">
        <FadeIn data-id="element-93">
          <div className="text-center mb-12" data-id="element-94">
            <div className="inline-flex items-center justify-center p-3 bg-amber-900/30 rounded-full mb-6 border border-amber-700/50" data-id="element-95">
              <Activity className="w-8 h-8 text-amber-500" data-id="element-96" />
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-amber-500 mb-6" data-id="element-97">
              La solución se llama Lubricación Sinovial Activa (LSA)
            </h2>
          </div>

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed text-stone-300" data-id="element-98">
            <p data-id="element-99">
              Es un sistema de 7 movimientos oscilatorios diseñados
              específicamente para hombres de más de 45 años.
            </p>
            <div className="bg-stone-900/80 p-8 rounded-2xl border-l-4 border-amber-500 shadow-2xl" data-id="element-100">
              <p data-id="element-101">
                A diferencia del ejercicio común, el método LSA se realiza{' '}
                <strong className="text-stone-50" data-id="element-102">"bajo las sábanas"</strong>,
                aprovechando el calor corporal para bombear aceite natural
                (líquido sinovial) a tus rodillas, cadera y espalda antes de que
                tus pies toquen el suelo.
              </p>
              <p className="mt-6 text-amber-200/80 italic" data-id="element-103">
                Es como calentar el motor de un coche clásico antes de salir a
                la carretera: evita el desgaste y garantiza un viaje suave.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}